// extracted by mini-css-extract-plugin
module.exports = {"shared":"\"../../../shared.module.css\"","lg":"992px","container":"Layout_container__2iQbi"};